export const GRAPHQL_URL = '/graphql';
